import { Skeleton } from '@mui/material'
import { FC } from 'react'

const RelatedQaItemSkeleton: FC = () => (
  <div
    className='mt8 bg-white pv6 ph4 ph5-ns bt-thick b--dark-cerulean w-100 o-hidden wb-word shadow-1'
  >
    <nav
      className='flex flex-wrap items-center f7 mb2 dark-cerulean lh-copy w-100 wb-word'
    >
      <span className='w-50'><Skeleton variant='text' /></span>
    </nav>
    <a
      className='f4 db w-100'
    >
      <Skeleton variant='text' />
    </a>
    <div
      className='grey mb5 h4 o-hidden no-pointer-events wb-word ws-normal w-100 f5 min-h4 relative content-view'
    >
      <Skeleton variant='text' />
      <Skeleton variant='text' />
    </div>
  </div>
)

const RelatedQaSkeleton: FC = () => (
  <div className='layout-width-constraint'>
    {[0, 0, 0, 0, 0, 0].map((_, idx) => <RelatedQaItemSkeleton key={idx} />)}
  </div>
)

export default RelatedQaSkeleton
